import BigNumber from "bignumber.js";

const TOKEN_DECIMALS = process.env.REACT_APP_VLAUNCH_DECIMALS;

export const convertFromWei = (
  value: number,
  decimals: BigNumber.Value = 18
) => {
  if (!value) {
    return new BigNumber(0);
  }
  return new BigNumber(value).div(new BigNumber(10).pow(decimals));
};

export const convertFromWeiFormatted = (
  value: number,
  decimals = 18,
  decimalNumber = 0
) => convertFromWei(value, decimals).toFixed(decimalNumber);

export const getFormattedValue = (
  value: number,
  minFractionDigits = 0,
  maxFractionDigits = 0
) => {
  return Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  }).format(value);
};

export const getStakedReadable = (stakedAmount: number) =>
  convertFromWei(stakedAmount, TOKEN_DECIMALS);

const getSeconds = (time: number) => {
  const timeNow = Math.round(new Date().getTime() / 1000);
  return timeNow - time;
};

export const userAPY = async (
  canClaim: number,
  lastClaim: number,
  amountStake: number
) => {
  const totalAPYcalc = (
    (((canClaim / getSeconds(lastClaim)) * 60 * 60 * 24 * 365) / amountStake) *
    100
  ).toFixed(2);
  return getFormattedValue(Number(totalAPYcalc));
};
